import Lookup from "../../../../types/functions/Lookup";
import IngestionConfig from "../../../../types/ingestion/IngestionConfig";
import Dictionary from "../../../../types/report/Dictionary";
import ReportFieldDefinition from "../../../../types/report/ReportFieldDefinition";
import Selector from "../../../../types/report/Selector";
import UserDefinedFunction from "../../../../types/report/UserDefinedFunction";
import assignmentHelper from "../assignment/assignmentHelper";
import assignmentItemHelper from "../assignment/assignmentItemHelper";
import declarationValidator from "./declarationValidator";

const validateSelectorWithKeys = (selectors: Selector[], functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[],
    dictionaries: Dictionary[], dataSources: IngestionConfig[], reportFields: ReportFieldDefinition[], type: string, reportConfigType: string) => {

    selectors.forEach(selector => {
        selector.keys?.forEach((key) => {
            let items = assignmentHelper.asCollection(key.assignment);
            let details = items.map(assignmentItemHelper.getDetails);

            selector.errors = [];
            
            items.forEach((x, i) => {

                declarationValidator.validateItem(selector.errors, x, details[i], functions, globalFunctions, lookups, dictionaries, [], dataSources, reportFields, null as any, type, null, false, reportConfigType);
            });
        });
    });

    let numbers = selectors
        .filter(a => a.errors.length > 0)
        .map(a => a.number);

    return numbers;
}

export default validateSelectorWithKeys;